import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import * as API from "../../Endpoints/Endpoints";

const ViewPlay = () => {
  const [playData, setPlayData] = useState();
  const { playid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getPlayData = async () => {
      try {
        const response = await axios.get(API.GET_PLAY_BYID(playid)); // Define API in Endpoints.js
        setPlayData(response.data[0]);
      } catch (error) {
        console.error("Error fetching play data:", error);
      }
    };

    if (playid) getPlayData();
  }, [playid]);

  const deletePlay = async (playid) => {
    try {
      await axios.delete(API.DELETE_PLAY_API(playid)); // Define API in Endpoints.js
      alert("Play entry deleted successfully");
      navigate("/playtable");
    } catch (error) {
      alert("Failed to delete play entry");
      console.error(
        "Error deleting play entry:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const goBack = () => {
    navigate("/playdbtable");
  };

  return (
    <div className="py-16 bg-[#f5f5f5] h-full">
      <div className="container px-6 m-auto text-gray-700 md:px-12 xl:px-0">
        <div className="grid gap-6 mx-auto md:w-3/6 lg:w-full lg:grid-cols-1">
          <div className="bg-white rounded-2xl shadow-lg px-8 py-12 sm:px-12 lg:px-8">
            <div className="mb-12 space-y-6">
              {playData ? (
                <div>
                  <h5 className="text-2xl font-semibold text-[#e64a32]">
                    Play Details
                  </h5>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col">
                      <span className="font-bold">Game Category</span>
                      <span>{playData.selectedCategory}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Name</span>
                      <span>{playData.selectedGamename}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Card Group</span>
                      <span>{playData.selectedCardGroups}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Scenario</span>
                      <span>{playData.scenario}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">User Input</span>
                      <span>{playData.userInput}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Time Elapsed</span>
                      <span>
                        {typeof playData.timeElapsed === "object"
                          ? `${playData.timeElapsed.seconds} seconds`
                          : playData.timeElapsed}
                      </span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Score</span>
                      <span>{playData.score}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-6 space-x-4">
                    <button
                      className="bg-[#e64a32] text-white hover:bg-[#e64a32] font-bold py-2 px-4 rounded"
                      onClick={() => deletePlay(playData.playid)}
                    >
                      Delete
                    </button>
                    <button
                      className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded"
                      onClick={goBack}
                    >
                      &#8592; Go Back
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-500">Loading play details...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPlay;
